import { Component } from '@angular/core';

@Component ({
    templateUrl: '403.html',
    styles: ['403.css']
})

export class Page403Component {
    constructor() { }
}